import { INTERCOM_APP_ID } from '@/utils/constants/integrations';
import { WITHOUT_TRACKERS } from '@/utils/constants/api';

export const isTrackersEnabled = () => process.env.NODE_ENV === 'production' && !WITHOUT_TRACKERS;

/**
 * Init Intercom integration, works only on production. User information will pass to the Intercom if user exists.
 * @param user need for setting up user information to Intercom chat
 */
export const intercomInit = (user) => {
  if (!isTrackersEnabled()) {
    return;
  }
  window.intercomSettings = {
    app_id: INTERCOM_APP_ID,
    hide_default_launcher: true,
    name: user?.name,
    email: user?.email,
    created_at: !user ? null : Math.floor(new Date(user.created_at).getTime() / 1000),
    user_id: user?.id.toString(),

    // Generates only on production backend for verifying specific user information
    // More info: https://www.intercom.com/help/en/articles/183-enable-identity-verification-for-web-and-mobile
    user_hash: user?.intercom_user_hash,
  };

  (function () {
    var w = window;
    var ic = w.Intercom;
    if (typeof ic === 'function') {
      ic('reattach_activator');
      ic('update', w.intercomSettings);
    } else {
      var d = document;
      var i = function () {
        i.c(arguments);
      };
      i.q = [];
      i.c = function (args) {
        i.q.push(args);
      };
      w.Intercom = i;
      var l = function () {
        var s = d.createElement('script');
        s.type = 'text/javascript';
        s.async = true;
        s.src = 'https://widget.intercom.io/widget/vtipe3ia';
        var x = d.getElementsByTagName('script')[0];
        x.parentNode.insertBefore(s, x);
      };
      if (document.readyState === 'complete') {
        l();
      } else if (w.attachEvent) {
        w.attachEvent('onload', l);
      } else {
        w.addEventListener('load', l, false);
      }
    }
  })();
};

export function openSupportChat() {
  if (isTrackersEnabled()) {
    // eslint-disable-next-line
    window.Intercom('show');
  } else {
    alert('Intercom works only in production');
  }
}
